import * as yup from 'yup';

import { DetailsFormFields } from '../types';

export const detailsFormValidationSchema = yup.object({
  [DetailsFormFields.status]: yup.string().nullable().required(),
});
